import React, { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth } from './redux/slices/authSlice';
import { selectTheme } from './redux/slices/themeSlice';
import Sidebar from './components/Layout/Sidebar';
import Loader from './components/Common/Loader';

const LoginPage = lazy(() => import('./pages/Auth/LoginPage'));
const DashboardPage = lazy(() => import('./pages/Dashboard/DashboardPage'));
const CompaniesPage = lazy(() => import('./pages/Companies/CompaniesPage'));
const CompanyDetailPage = lazy(() => import('./pages/CompanyDetail/CompanyDetailPage'));
const ConversationsPage = lazy(() => import('./pages/Conversations/ConversationsPage'));
const LeadsPage = lazy(() => import('./pages/Leads/LeadsPage'));
const KnowledgePage = lazy(() => import('./pages/Knowledge/KnowledgePage'));
const AnalyticsPage = lazy(() => import('./pages/Analytics/AnalyticsPage'));
const SettingsPage = lazy(() => import('./pages/Settings/SettingsPage'));
const AdminsPage = lazy(() => import('./pages/Admin/AdminsPage'));
const UsersPage = lazy(() => import('./pages/Users/UsersPage'));
const NotFoundPage = lazy(() => import('./pages/NotFound/NotFoundPage'));

const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<Loader fullPage text="Loading..." />}>{children}</Suspense>
);

const ProtectedRoute = ({ children }) => {
  const { admin } = useSelector(selectAuth);
  if (!admin) return <Navigate to="/login" replace />;
  return <div className="admin-layout"><Sidebar /><div className="main-content">{children}</div></div>;
};

function App() {
  const theme = useSelector(selectTheme);
  useEffect(() => { document.documentElement.setAttribute('data-theme', theme); }, [theme]);

  return (
    <SuspenseWrapper>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/companies" element={<ProtectedRoute><CompaniesPage /></ProtectedRoute>} />
        <Route path="/companies/:id" element={<ProtectedRoute><CompanyDetailPage /></ProtectedRoute>} />
        <Route path="/conversations" element={<ProtectedRoute><ConversationsPage /></ProtectedRoute>} />
        <Route path="/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
        <Route path="/knowledge" element={<ProtectedRoute><KnowledgePage /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/admins" element={<ProtectedRoute><AdminsPage /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </SuspenseWrapper>
  );
}

export default App;
